import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, InputSignal, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'details-date-range',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  templateUrl: './date-range.component.html',
  styleUrl: './date-range.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class DetailsDateRangeComponent{
    public start: InputSignal<string> = input.required<string>();
    public end: InputSignal<string> = input.required<string>();
}